import React, { createContext, useContext, useState, useEffect } from 'react';

interface WindowWidthContextType {
    windowWidth: number;
}

const WindowWidthContext = createContext<WindowWidthContextType | undefined>(undefined);

export function WindowWidthProvider({ children }: { children: React.ReactNode }) {
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return (
        <WindowWidthContext.Provider value={{ windowWidth }}>
            {children}
        </WindowWidthContext.Provider>
    );
}

export function useWindowWidth() {
    const context = useContext(WindowWidthContext);
    if (context === undefined) {
        throw new Error('useWindowWidth must be used within a WindowWidthProvider');
    }
    return context.windowWidth;
}

